import { SET_SIDER_WIDTH, RESET_SIDER_WIDTH } from './actionTypes';

export const setWidth = (position, newWidth) => ({
  type: SET_SIDER_WIDTH,
  payload: { position, newWidth },
});

export const resetWidth = position => ({
  type: RESET_SIDER_WIDTH,
  payload: { position },
});



// WEBPACK FOOTER //
// ./src/components/page/EnhancedSider/flow/actions.js